import { compose } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useChangeSort } from '@btime/react-contexts'
import { useTranslatedFormattedOptionsFromArray } from '../../../../../utils/hooks/select'
import SortSideModal from '../../../../../components/filter/SortSideModal'

const SORT_OPTIONS = ['NAME', 'INSERTED_AT', 'UPDATE_AT']

const PlacesSortModal = ({ open, onClose }) => {
  const { t } = useTranslation('listPlaces')

  const sortOptions = useTranslatedFormattedOptionsFromArray(t, 'fields.', SORT_OPTIONS)
  const setSort = useChangeSort()
  const updateSortState = ({ field, type }) => setSort(field, type)
  const onSubmitSort = compose(onClose, updateSortState)

  return <SortSideModal open={open} onClose={onClose} fields={sortOptions} onSubmit={onSubmitSort} />
}

export default PlacesSortModal
